import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

type ITrainingSetRevokeCertificationMutationParams = {
  trainingSetId: string;
};

export const useTrainingSetRevokeCertification = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: ITrainingSetRevokeCertificationMutationParams) => {
      return await (await glynt).trainingSet.revokeCertification(data.trainingSetId);
    },

    ...callbacks
  });
};
